import axios from 'axios'
import store from '../store'
import router from "../router";

axios.interceptors.request.use(req => {
  try {
    req.baseURL = process.env.VUE_APP_API_URL;
    req.headers.common['Access-Control-Allow-Origin'] = '*';
    req.headers.common['Content-Type'] = 'application/json';

    let token = null;

    if (req.url !== '/api/login') {
      token = store.getters['token'];
    }

    if (token) {
      req.headers.common.Authorization = `Bearer ${token}`
    }
  }
  catch(ex) {
    console.log('request exception: ', ex);
  }

  return req
});

// Response interceptor
axios.interceptors.response.use(response => response, error => {
  const { status } = error.response ? error.response : error;
  console.log('request error: ', error, 'status', status);

  const isAdminArea = window.location.href.toString().indexOf('/a/') > -1;

  if(status === 403 && isAdminArea) {
      router.push({
        path: '/a/login'
      });
  }

  return Promise.reject(error)
})

export default axios;
